import React from 'react';

const INSIGHT_CONFIGS = [
  { key: 'busiest_month', title: 'Busiest Month', unit: 'shipments' },
  { key: 'top_customer',  title: 'Top Customer',  unit: 'shipments' },
  { key: 'top_item',      title: 'Top Item',       unit: 'cases' },
  { key: 'peak_season',   title: 'Peak Season',    unit: '' },
];

const InsightsPills = ({ insights, loading, onStatClick }) => {
  if (loading) {
    return (
      <div className="insights-strip">
        {INSIGHT_CONFIGS.map(c => (
          <div key={c.key} className="insight-pill insight-pill--skeleton">
            <span className="insight-pill__number">--</span>
            <span className="insight-pill__body">
              <span className="insight-pill__label">{c.title}</span>
              <span className="insight-pill__value">Loading...</span>
            </span>
          </div>
        ))}
      </div>
    );
  }

  if (!insights) return null;

  return (
    <div className="insights-strip">
      {INSIGHT_CONFIGS.map(c => {
        const data = insights[c.key];
        if (!data) return null;
        return (
          <div
            key={c.key}
            className="insight-pill insight-pill--clickable"
            onClick={() => onStatClick && onStatClick(c.key)}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && onStatClick && onStatClick(c.key)}
          >
            <span className="insight-pill__number-wrap">
              <span className="insight-pill__number">{data.value}</span>
              {c.unit && <span className="insight-pill__unit">{c.unit}</span>}
            </span>
            <span className="insight-pill__body">
              <span className="insight-pill__label">{c.title}</span>
              <span className="insight-pill__value">{data.label}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default InsightsPills;
